var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.791 22.362C33.4577 22.7469 33.4577 23.7092 32.791 24.0941L19.3957 31.8278C18.7291 32.2127 17.8958 31.7316 17.8958 30.9618L17.8958 15.4943C17.8958 14.7245 18.7291 14.2433 19.3958 14.6282L32.791 22.362Z",
    fill: "#1D4EAF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.3605,
    cy: 23.2282,
    r: 22.1804,
    stroke: "#1D4EAF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8418732cbac5c2794f600d061b5724d2.svg";
export { ForwardRef as ReactComponent };